import { atom } from "jotai";
import { EPHEMERAL_NODE_TYPES } from "@zapier/canvas-constants";
import {
  isTemplateNode,
  isDraftNode,
  determineAssetType,
  getAssetId,
} from "../utils";
import { DefaultNodeData, EphemeralNodeType, NodeType } from "../types";
import { nodesAtom } from "./nodesAtom";

export const isDraftModeExcludingTemplatesAtom = atom((get) => {
  const nodes = get(nodesAtom);
  return nodes.some((node) => {
    // skip nodes we never persist
    const isNotEphemeral = !EPHEMERAL_NODE_TYPES.includes(
      node.type as EphemeralNodeType,
    );
    const assetType = determineAssetType(
      (node.data as DefaultNodeData)?.services,
      node.type as NodeType,
    );
    const assetId = getAssetId(node.data, assetType);
    const isDraft = isDraftNode({ assetId, assetType });
    const isNotTemplate = !isTemplateNode(node.id);

    return isNotEphemeral && isDraft && isNotTemplate;
  });
});

isDraftModeExcludingTemplatesAtom.debugLabel =
  "isDraftModeExcludingTemplatesAtom";
